<template>
  <!-- This row is the title -->
  <div class="d-flex h-40 flex-column">
    <div class="loading abcenter" v-if="showOverlay">
      <div class="spinner-grow text-primary abcenter" role="status"></div>
    </div>
    <b-modal id="askwarning" title="NEURON warning" hide-header-close ok-only>{{ qawarningtext }}</b-modal>
    <!-- header row -->
    <div class="row text-center m-1">
      <div class="col-sm-4">
        <span class="thick">Question</span>
      </div>
      <div class="col-sm-4">
        <span class="thick">Answer</span>
      </div>
      <div class="col-sm-4">
        <span class="thick">Feedback</span>
      </div>
    </div>
    <!-- This row is the text boxes -->
    <div class="row flex-fill mb-3">
      <div class="col-sm-4 d-flex flex-column">
        <form @submit.prevent="sendQuestion" class="flex-fill d-flex flex-column">
          <div class="form-group">
            <label for="questionType">Question</label>
            <select class="form-control" id="questionType" v-model="selectedQuestion" :disabled="!planAvailable">
              <option value="row">How many rows are left after a certain step?</option>
              <option value="operator">What are the operators used?</option>
              <option value="definition">What does an operator do?</option>
              <option value="time">How long does it take to run a certain step?</option>
              <option value="expensive">What is the most expensive step?</option>
              <option value="inexpensive">What is the most inexpensive step?</option>
            </select>
          </div>
          <div class="form-group" v-if="selectedQuestion === 'row' || selectedQuestion === 'time'">
            <label for="stepNumber">Step</label>
            <input
              type="number"
              class="form-control"
              id="stepNumber"
              v-model="stepNumber"
              placeholder="Enter the step number"
              :disabled="!planAvailable"
              required
            />
          </div>
          <div class="form-group" v-if="selectedQuestion === 'definition'">
            <label for="operatorName">Operator</label>
            <input
              class="form-control"
              id="operatorName"
              v-model="operatorName"
              placeholder="Enter the operator name"
              :disabled="!planAvailable"
              required
            />
          </div>
          <div class="text-center mt-auto">
            <button type="submit" class="btn btn-primary" :disabled="!planAvailable">Submit</button>
          </div>
        </form>
      </div>
      <div class="col-sm-4">
        <textarea v-model="answertext" class="form-control form-control-plaintext h-100" readonly></textarea>
      </div>
      <div class="col-sm-4 d-flex flex-column">
        <div class="row flex-fill">
          <textarea v-model="feedbacktext" class="form-control h-100" placeholder="Please provide your feedback here..."></textarea>
        </div>
        <div class="text-center mt-auto">
          <button type="button" class="btn btn-primary" v-on:click="submitFeedback()">Submit</button>
          <!-- <router-link to="/add-poem" class="btn btn-primary">Add POEM</router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { askNoNLP, feedback } from '@/api.js'

export default {
  data: function () {
    return {
      questiontext: '',
      answertext: '',
      qawarningtext: '',
      showOverlay: false,
      selectedQuestion: 'row',
      stepNumber: '',
      operatorName: '',
      feedbacktext: ''
    }
  },
  computed: {
    ...mapState(['planAvailable', 'email'])
  },
  watch: {
    planAvailable(newVal, oldVal) {
      if (newVal === false) {
        this.questiontext = ''
        this.answertext = ''
      }
    }
  },
  methods: {
    async sendQuestion() {
      // send HTTP request
      this.showOverlay = true
      try {
        let questionData = { type: this.selectedQuestion }
        if (this.selectedQuestion === 'time' || this.selectedQuestion === 'row') {
          questionData.step = parseInt(this.stepNumber, 10)
        } else if (this.selectedQuestion === 'definition') {
          questionData.keyword = this.operatorName
        }
        let response = await askNoNLP(questionData,this.email)
        this.showOverlay = false
        if (response.data['code'] === 'f') {
          this.qawarningtext = response.data['text']
          this.$bvModal.show('askwarning')
        } else {
          this.answertext = response.data['text']
        }
      } catch (err) {
        this.showOverlay = false
      }
    },
    async submitFeedback() {
      if (this.feedbacktext !== '') {
        await feedback(this.email, this.feedbacktext)
      } else {
        this.qawarningtext = 'Please input your feedback before submitting!'
        this.$bvModal.show('askwarning')
        return
      }
      this.acktext = 'We have recorded your feedback, thank you!'
      this.$bvModal.show('acknowledgement')
      this.clearFeedback()
    },
    clearFeedback() {
      this.feedbacktext = ''
    }
  }
}
</script>
